import Vue from 'vue';

Vue.filter('stripHtml', (value) => {
    if (!value) return '';
    const tmp = document.createElement('div');
    tmp.innerHTML = value;
    return tmp.textContent || tmp.innerText || '';
});
